export const getAppRunUuidFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('appRunUuid');
};
